<template>
  <form :id="widgetType" @submit.prevent="addNewWidget">

    <CommunInputs :widgetConfig="widgetConfig" >
    </CommunInputs>
   
    <label for="" class="form-label">Cantidad de Decimales</label>
    <input required
      class="form-control"
      v-model="widgetConfig.decimalPlaces"
      label="Cantidad de Decimales"
      type="number"
      @input="validateCount(widgetConfig)"
    />

    <label for="" class="form-label">Frencuencia de Envio</label>
    <input required
      class="form-control"
      v-model="widgetConfig.variableSendFreq"
      label="Send Freq"
      type="text"
    />

    <label for="" class="form-label">Icono</label>
    <IconsForm :value="widgetConfig"></IconsForm>

    <label for="" class="form-label">Unidad</label>
    <input required
      class="form-control"
      v-model="widgetConfig.unit"
      label="unidad"
      type="text"
    />

    <label for="" class="form-label">Seleccionar Color</label>
    <select
      v-model="widgetConfig.class"
      class="form-select"
      placeholder="Seleccionar color"
      style="width: 100%"
    >
      <option class="text-success" value="success" label="Success"></option>
      <option class="text-primary" value="primary" label="Primary"></option>
      <option class="text-warning" value="warning" label="Warning"></option>
      <option class="text-danger" value="danger" label="Danger"></option>
    </select>

  </form>
</template>

<script>
import IconsForm from './IconsForm.vue';
import CommunInputs from './common/CommunInputs.vue';
export default {
  props: ["widgetConfig", "addNewWidget", "validateCount", "widgetType"],
  components:{
    IconsForm,
    CommunInputs
  }
};
</script>
